import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import moment from 'moment';
require("moment-duration-format");

const styles = theme => ({
  textField: {
    width: 170,
  },
  marginRight: {
    marginRight: theme.spacing(2),
  },
})

class RoomScheduleDetailDialog extends Component {
  state = {
    open: this.props.open,
  };

  handleRequestClose = () => {
    this.setState({ open: false });
    this.props.onRequestClose();
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.state.open) {
      this.setState({ open: nextProps.open });
    }
  }

  render() {
    if (!this.props.scheduleRow) {
      return null;
    }

    const { classes } = this.props;

    return (
      <Dialog
        onClose={this.handleRequestClose}
        open={this.state.open}>
        <DialogTitle>Booking Detail</DialogTitle>
        <DialogContent>
          <div>
            {/* Customer */}
            <Typography variant="h6" color="textSecondary">Customer</Typography>
            <div style={{ display: 'flex', flexWrap: 'wrap', }}>
              <TextField
                InputLabelProps={{ shrink: true, }}
                className={`${classes.textField} ${classes.marginRight}`}
                disabled
                label="Name"
                value={(this.props.scheduleRow.customer && this.props.scheduleRow.customer.name) || ''}
                margin="normal" />
              <TextField
                InputLabelProps={{ shrink: true, }}
                className={`${classes.textField} ${classes.marginRight}`}
                disabled
                label="Phone"
                value={(this.props.scheduleRow.customer && this.props.scheduleRow.customer.phone) || ''}
                margin="normal" />
              <TextField
                InputLabelProps={{ shrink: true, }}
                className={`${classes.textField}`}
                disabled
                label="Email"
                value={(this.props.scheduleRow.customer && this.props.scheduleRow.customer.email) || ''}
                margin="normal" />
            </div>
            <br/>
            {/* Booking */}
            <Typography variant="h6" color="textSecondary">Booking</Typography>
            <div style={{ display: 'flex', flexWrap: 'wrap', }}>
              <TextField
                InputLabelProps={{ shrink: true, }}
                className={`${classes.textField} ${classes.marginRight}`}
                disabled
                label="Start time"
                value={moment(this.props.scheduleRow.bookingStartTime).format('LT')}
                margin="normal" />
              <TextField
                InputLabelProps={{ shrink: true, }}
                className={`${classes.textField} ${classes.marginRight}`}
                disabled
                label="End Time"
                value={moment(this.props.scheduleRow.bookingEndTime).format('LT')}
                margin="normal" />
              <TextField
                InputLabelProps={{ shrink: true, }}
                className={`${classes.textField}`}
                disabled
                label="Duration"
                value={moment.duration(moment(this.props.scheduleRow.bookingEndTime).diff(this.props.scheduleRow.bookingStartTime)).format()}
                margin="normal" />
            </div>
            <br/>
            {/* Others */}
            <Typography variant="h6" color="textSecondary">Others</Typography>
            <div style={{ display: 'flex', flexWrap: 'wrap', }}>
              <TextField
                InputLabelProps={{ shrink: true, }}
                className={`${classes.textField} ${classes.marginRight}`}
                disabled
                label="Booking made on"
                value={
                  this.props.scheduleRow.bookingCreateTime ?
                  moment(this.props.scheduleRow.bookingCreateTime).format('lll') :
                  ''
                }
                margin="normal" />
            </div>

          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleRequestClose} >Close</Button>
        </DialogActions>
      </Dialog>
    );
  }
}

RoomScheduleDetailDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  scheduleRow: PropTypes.object,
};

export default withStyles(styles)(RoomScheduleDetailDialog);
